/**
 * Splits `items` into contiguous chunks of at most `size`.
 * @param items - Source array.
 * @param size - Maximum chunk length; must be a positive integer.
 * @returns Array of chunks (empty when `items` is empty).
 * @example
 * chunkArray([1, 2, 3, 4, 5], 2); // [[1, 2], [3, 4], [5]]
 */
export function chunkArray<T>(items: T[], size: number): T[][] {
  if (size <= 0) {
    throw new Error('chunkArray size must be a positive number');
  }

  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}
